/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Item } from 'libs/sysque/toolbelt/data-access/src/lib/domain/item';
import { TooltipItem } from 'libs/sysque/toolbelt/data-access/src/lib/domain/tooltip-item';
import { CableTrayConduitBase } from '../../../../../../shared/ui/src/lib/enums/cable-tray-conduit-base';

export class TooltipItemInfo {
  tooltipItems: TooltipItem[] = [];

  getTooltipItemInfo(item: Item, category: string): TooltipItem[] {
    this.tooltipItems = [];
    if(item.itemType === 'ElectricalTypeItems') {
      this.getTooltipForElectricalItem(item);
    }else{
      this.getTooltipForDefaultItem(item, category);
    }
    return (this.tooltipItems = this.tooltipItems.filter(
      (x) => x.value !== '' && x.value !== null && x.value !== undefined
    ));
  }

  //#region Tooltip for Electrical items

  getTooltipForElectricalItem(item: Item): void {
    if(item.shape === 'FieldFabConduit'){
      this.getTooltipForFieldFab(item);
    } else{
      this.getTooltipForCableTrayOrConduit(item);
    }
  }

  getTooltipForFieldFab(item: Item): void{
    this.getPrimaryTooltipsForElectrical(item);
    this.tooltipItems.push(
      { header: 'Sizes', value: item.sizeRange, valueAsArray: this.arrangeSizesTooltip(item.sizeRange) },
      { header: 'Bend Radii', value: item.bendRadius, valueAsArray: this.arrangeSizesTooltip(item.bendRadius) },
      { header: 'Lead Length', value: item.leadLength, valueAsArray: this.arrangeSizesTooltip(item.leadLength) }
    );
    this.getServiceTypeTooltips(item.serviceType, item.serviceTypeColor);
  }

  getTooltipForCableTrayOrConduit(item: Item): void{
    this.getPrimaryTooltipsForElectrical(item);
    this.tooltipItems.push({ header: 'Sizes', value: item.sizeRange, valueAsArray: this.arrangeSizesTooltip(item.sizeRange) });
    this.getServiceTypeTooltips(item.serviceType, item.serviceTypeColor);
  }

  //#endregion
  
  //#region Tooltip for Default items

  getTooltipForDefaultItem(item: Item, category: string): void {
    if(item.shape === 'CustomContent'){
      this.getTooltipForCustomContent(item);
    } else{
      this.getTooltipForOthers(item, category);
    }
  }

  getTooltipForCustomContent(item: Item): void {
    this.getPrimaryTooltipsForDefault(item)
    this.tooltipItems.push(
      { header: 'Manufacturer', value: item.manufacturer, valueAsArray: [] },
      { header: 'Category', value: item.category, valueAsArray: [] }
    );
  }

  getTooltipForOthers(item: Item, category: string): void {
    this.getPrimaryTooltipsForDefault(item);
    if(category in CableTrayConduitBase){
      this.tooltipItems.push({ header: 'Angle', value: item.angle, valueAsArray: [] });
    }
    this.getVerticalTeeTooltip(item);
    this.tooltipItems.push(
      { header: 'Shape', value: item.shape, valueAsArray: [] },
      { header: 'Manufacturer', value: item.manufacturer, valueAsArray: [] },
      { header: 'Sizes', value: item.sizeRange, valueAsArray: this.arrangeSizesTooltip(item.sizeRange) }
    );
  }

  getVerticalTeeTooltip(item: Item): void {
    const isFittingTypeTee = (item.fittingType === 'LadderCableTrayTee' || item.fittingType === 'ChannelCableTrayTee');
    if(isFittingTypeTee && item.bendType){
      this.tooltipItems.push({ header: 'TeeType', value: item.bendType, valueAsArray: [] });
    } else{
      this.tooltipItems.push({ header: 'Position', value: item.position, valueAsArray: [] });
    }
  }

  //#endregion

  //#region Common methods

  getPrimaryTooltipsForElectrical(item: Item): void {
    this.tooltipItems.push(
      { header: 'Connectors', value: item.connectors, valueAsArray: [] },
      { header: 'Shape', value: item.shape, valueAsArray: [] },
      { header: 'Length', value: item.lengthTooltip, valueAsArray: [] },
      { header: 'Manufacturer', value: item.manufacturer, valueAsArray: [] },
    );
  }

  getPrimaryTooltipsForDefault(item: Item): void {
    this.tooltipItems.push(
      { header: 'Fitting Type', value: item.fittingType, valueAsArray: [] },
      { header: 'Connectors', value: item.connectors, valueAsArray: [] }
    );
  }

  getServiceTypeTooltips(serviceType: string, serviceColor: string): void {
    if(serviceType){
      this.tooltipItems.push({ header: 'Service Type', value: serviceType, valueAsArray: [] });
    }
    if(serviceColor){
      this.tooltipItems.push({ header: 'Service Color', value: serviceColor, valueAsArray: [] });
    }
  }

  arrangeSizesTooltip(sizeInFormat: string): string[]{
    if(sizeInFormat === null || sizeInFormat === undefined || sizeInFormat === ''){ 
      return []; 
    }
    return sizeInFormat.split(",");
  }

  //#endregion
}